// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.html-response-viewer {
    margin-top: 2rem;
}

.html-raw,
.html-rendered {
    border: 1px solid #ccc;
    padding: 1rem;
    margin-top: 1rem;
}

.html-raw pre {
    font-size: 1.4rem;
    white-space: pre-wrap;
    background-color: #f7f7f7;
    padding: 1rem;
    overflow-x: auto;
}

.html-rendered div {
    font-size: 1.4rem;
    padding: 1rem;
    background-color: #fafafa;
}`, "",{"version":3,"sources":["webpack://./src/components/HtmlResponseViewer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".html-response-viewer {\n    margin-top: 2rem;\n}\n\n.html-raw,\n.html-rendered {\n    border: 1px solid #ccc;\n    padding: 1rem;\n    margin-top: 1rem;\n}\n\n.html-raw pre {\n    font-size: 1.4rem;\n    white-space: pre-wrap;\n    background-color: #f7f7f7;\n    padding: 1rem;\n    overflow-x: auto;\n}\n\n.html-rendered div {\n    font-size: 1.4rem;\n    padding: 1rem;\n    background-color: #fafafa;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
